import { cn } from "@/lib/utils";

export function UpvoteShotIcon({ active = false }: { active?: boolean }) {
  return (
    <svg
      viewBox="0 0 32 32"
      aria-hidden="true"
      className={cn("h-5 w-5", active ? "text-[#A4243B]" : "text-zinc-500")}
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    >
      <path d="M5 21V7h22v14" />
      <path d="M10 21v-8h12v8" />
      <path d="M16 13v8" opacity=".45" />
      <circle cx="7" cy="26" r="3" fill="currentColor" stroke="none" />
      <path d="M11 24C15 19 19 15 25 12" />
      <path d="M21 11h5v5" />
      <path d="M24.5 12.5 22 15" opacity=".55" />
    </svg>
  );
}

export function DownvoteShotIcon({ active = false }: { active?: boolean }) {
  return (
    <svg
      viewBox="0 0 32 32"
      aria-hidden="true"
      className={cn("h-5 w-5", active ? "text-[#A4243B]" : "text-zinc-500")}
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    >
      <path d="M5 21V7h18v14" />
      <path d="M9 21v-8h10v8" />
      <path d="M14 13v8" opacity=".45" />
      <circle cx="7" cy="26" r="3" fill="currentColor" stroke="none" />
      <path d="M11 24c5-3 10-2 18 1" />
      <path d="M25 21l4 4-5 3" />
      <path d="M24 11h4" opacity=".55" />
    </svg>
  );
}
